export const en = {
  common: {
    welcome: "Welcome",
    loading: "Loading...",
    error: "Error",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    back: "Back",
  },
  auth: {
    signIn: "Sign in",
    signOut: "Sign out",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    rememberMe: "Remember for 30 days",
    enterEmail: "Enter your email address",
    enterPassword: "Enter your password",
    welcomeBack: "Welcome back! Please enter your details.",
    invalidCredentials: "Failed to sign in. Please check your credentials.",
  },
  navigation: {
    dashboard: "Dashboard",
    activityArea: "Activity Area",
    learningArea: "Learning Area",
    transactionSummary: "Transaction Summary",
    financialStatements: "Financial Statements",
    switchView: "Switch View",
    ameView: "AME View",
    userView: "User View",
  },
  cohort: {
    cohortOverview: "Cohort Overview",
    activeCohorts: "Active Cohorts",
    meetingPlatform: "Meeting Platform",
    trainer: "Trainer",
    language: "Language",
    status: "Status",
    created: "Created",
    notSpecified: "Not specified",
    notAssigned: "Not assigned",
    totalParticipants: "Total Participants",
    sessionsScheduled: "Sessions Scheduled",
    clientsInvolved: "Clients Involved",
    progress: "Progress",
    participants: "Participants",
    addParticipant: "Add Participant",
    editParticipant: "Edit Participant",
    deleteParticipant: "Delete Participant",
    participantName: "Name",
    participantEmail: "Email",
    participantJobTitle: "Job Title",
    client: "Client",
    noSessionsScheduled: "No sessions scheduled",
    dateTBD: "Date TBD",
    multipleClients: "Multiple Clients",
    noClients: "No clients",
    unknownClient: "Unknown Client",
  },
  messages: {
    confirmDelete: "Are you sure you want to delete this?",
    cannotBeUndone: "This action cannot be undone.",
    cohortLanguageNote: "Note: This cohort is in",
  },
};
